import { Box, Container, Stack, Typography } from '@mui/material'
import { CTAButtons } from './CTAButtons'

export function Section7() {
  return (
    <Container
      component={Box}
      py={8}
    >
      <Stack
        spacing={6}
        alignItems='center'
      >
        <Typography
          component='h2'
          variant='next:h2'
          fontWeight={700}
          textAlign='center'
        >
          Can I adjust territory lines on the fly?
        </Typography>
        <Typography
          component='p'
          variant='next:h6'
          color='text.secondary'
          textAlign='center'
          maxWidth='80ch'
        >
          Absolutely! Mapstack lets you drag, reshape, or split territories in
          real time. Instantly see how changes affect coverage or performance,
          then share updated boundaries with your team.
        </Typography>

        <CTAButtons />
      </Stack>
    </Container>
  )
}
